import { useEffect, useState } from "react";

/**
 * Whether this is a Mac desktop browser.
 *
 * Client-side because iPadOS Safari in desktop mode claims `Macintosh` with no
 * iPad token, so the request header alone can't tell the two apart. Only touch
 * support can, and only the browser sees it.
 *
 * Starts false so the first render matches a server-rendered one, then settles
 * after mount.
 */
export function useIsMacDesktop() {
  const [isMacDesktop, setIsMacDesktop] = useState(false);

  useEffect(() => {
    // `!` rather than `=== 0`: where `maxTouchPoints` is unimplemented it's
    // `undefined`, and `=== 0` would read that Mac as an iPad.
    setIsMacDesktop(
      navigator.userAgent.includes("Macintosh") && !navigator.maxTouchPoints
    );
  }, []);

  return isMacDesktop;
}
